/* eslint-disable no-magic-numbers */
export function getPastelColorFromString (str) {
    // Initialize the hash value to 0
    let hash = 0;

    // Loop through each character in the string
    for (let i = 0; i < str.length; i++) {
        // Add the character code multiplied by its position (+1) to the hash
        hash += str.charCodeAt(i) * (i + 1);
    }

    // Calculate the hue value based on the hash * the golden angle
    const hue = (hash * 137.5) % 360;

    // Return an HSL color string
    return `hsl(${hue}, 55%, 75%)`;
}

